import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { Filter } from '@gogame/filters';

import {
  FILTER_DATE,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_PLATFORMS,
  FILTER_CLUSTERS,
  FILTER_TRAFFIC_TYPE,
  FILTER_TIME_ZONE,
  FILTER_COUNTRIES,
  FILTER_AFFILIATES,
  FILTER_OWNERS,
  FILTER_MANAGERS,
  PERIOD_PRESETS,
} from '../../constants';
import {
  loadApplications,
  loadNetworks,
  loadClusters,
  loadPlatforms,
  loadTimeZones,
  loadTrafficTypes,
  loadAffiliates,
  loadOwners,
  loadCountries,
  loadManagers,
} from '../../sources/Filters';

const DEPENDENCIES = {
  [FILTER_NETWORKS]: [FILTER_APPLICATIONS],
  [FILTER_PLATFORMS]: [FILTER_APPLICATIONS, FILTER_NETWORKS],
  [FILTER_CLUSTERS]: [FILTER_APPLICATIONS, FILTER_NETWORKS],
  [FILTER_AFFILIATES]: [FILTER_APPLICATIONS, FILTER_NETWORKS, FILTER_CLUSTERS],
  [FILTER_OWNERS]: [
    FILTER_APPLICATIONS,
    FILTER_NETWORKS,
    FILTER_CLUSTERS,
    FILTER_AFFILIATES,
    FILTER_COUNTRIES,
    FILTER_MANAGERS,
  ],
  [FILTER_MANAGERS]: [
    FILTER_APPLICATIONS,
    FILTER_NETWORKS,
    FILTER_CLUSTERS,
    FILTER_AFFILIATES,
    FILTER_OWNERS,
    FILTER_COUNTRIES,
  ],
};

const DateFilter = (props) => {
  return (
    <Filter.DateRangePicker
      title={'Period'}
      presets={PERIOD_PRESETS}
      name={FILTER_DATE}
      maxDate={new Date()}
      maxRange={10}
      verticalFields={false}
      {...props}
    />
  );
};

const TimeZoneFilter = (props) => (
  <Filter.Select
    title={'Time Zone'}
    placeholder={'Time Zone'}
    name={FILTER_TIME_ZONE}
    source={loadTimeZones}
    depends={DEPENDENCIES[FILTER_TIME_ZONE]}
    multiFields={false}
    {...props}
  />
);

const ApplicationsFilter = (props) => (
  <Filter.MultiSelect
    title={'Applications'}
    placeholder={'All'}
    name={FILTER_APPLICATIONS}
    depends={DEPENDENCIES[FILTER_APPLICATIONS]}
    source={loadApplications}
    multiFields={false}
    {...props}
  />
);

const NetworksFilter = (props) => (
  <Filter.MultiSelect
    title={'Networks'}
    placeholder={'All'}
    name={FILTER_NETWORKS}
    depends={DEPENDENCIES[FILTER_NETWORKS]}
    source={loadNetworks}
    multiFields={false}
    withAll={false}
    {...props}
  />
);

const ClustersFilter = (props) => (
  <Filter.MultiSelect
    title={'Clusters'}
    placeholder={'All'}
    name={FILTER_CLUSTERS}
    depends={DEPENDENCIES[FILTER_CLUSTERS]}
    source={loadClusters}
    withAll={false}
    multiFields={false}
    {...props}
  />
);

const PlatformsFilter = (props) => (
  <Filter.MultiSelect
    title={'Platforms'}
    placeholder={'All'}
    name={FILTER_PLATFORMS}
    depends={DEPENDENCIES[FILTER_PLATFORMS]}
    source={loadPlatforms}
    withAll={true}
    multiFields={false}
    {...props}
  />
);

const TrafficTypeFilter = (props) => (
  <Filter.Select
    title={'Traffic'}
    placeholder={'All'}
    name={FILTER_TRAFFIC_TYPE}
    source={loadTrafficTypes}
    depends={DEPENDENCIES[FILTER_TRAFFIC_TYPE]}
    multiFields={false}
    {...props}
  />
);

const AffiliatesFilter = (props) => (
  <Filter.MultiSelect
    title={'Affiliates'}
    placeholder={'All'}
    name={FILTER_AFFILIATES}
    source={loadAffiliates}
    depends={DEPENDENCIES[FILTER_AFFILIATES]}
    multiFields={false}
    {...props}
  />
);

const CountriesFilter = (props) => (
  <Filter.MultiSelect
    title={'Countries'}
    placeholder={'All'}
    name={FILTER_COUNTRIES}
    source={loadCountries}
    depends={DEPENDENCIES[FILTER_COUNTRIES]}
    multiFields={false}
    {...props}
  />
);

const OwnersFilter = (props) => (
  <UserFilter
    title={'Owners'}
    placeholder={'All'}
    name={FILTER_OWNERS}
    source={loadOwners}
    depends={DEPENDENCIES[FILTER_OWNERS]}
    withAll={false}
    multiFields={false}
    {...props}
  />
);

const ManagersFilter = (props) => (
  <Filter.MultiSelect
    title={'Managers'}
    placeholder={'All'}
    name={FILTER_MANAGERS}
    source={loadManagers}
    depends={DEPENDENCIES[FILTER_MANAGERS]}
    withAll={false}
    multiFields={false}
    {...props}
  />
);

export default {
  Date: DateFilter,
  Applications: ApplicationsFilter,
  Networks: NetworksFilter,
  Platforms: PlatformsFilter,
  Clusters: ClustersFilter,
  TrafficType: TrafficTypeFilter,
  TimeZone: TimeZoneFilter,
  Countries: CountriesFilter,
  Affiliates: AffiliatesFilter,
  Owners: OwnersFilter,
  Managers: ManagersFilter,
};
